import clsx from "clsx";
import { useMemo, useState } from "react";
import { MdInfoOutline } from "react-icons/md";
import AlertDialog from "../AlertDialog/AlertDialog";
import useMobile from "src/hooks/useMobile";
import { ICON_SIZES } from "src/constants/icons";

export enum EModalMessageKind {
  INFO = "INFO",
  WARNING = "WARNING",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

interface IModalFooterMessage {
  message: string;
  kind: EModalMessageKind;
  hideTextInMobile?: boolean;
}

const ModalFooterMessage: React.FC<IModalFooterMessage> = ({
  message,
  kind = EModalMessageKind.INFO,
  hideTextInMobile = true,
}) => {
  const { isMobile } = useMobile();
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const iconClasses = useMemo(() => {
    switch (kind) {
      case EModalMessageKind.ERROR: {
        return ["text-red-500", "dark:text-purple-400", "opacity-80"];
      }
      case EModalMessageKind.SUCCESS: {
        return ["text-green-500", "dark:text-purple-400", "opacity-80"];
      }
      case EModalMessageKind.WARNING: {
        return ["text-yellow-500", "dark:text-purple-400", "opacity-80"];
      }
      default: {
        return ["text-blue-500", "dark:text-purple-400", "opacity-80"];
      }
    }
  }, [kind]);

  const iconSize = useMemo(() => {
    if (isMobile) {
      return ICON_SIZES.SM;
    }

    return ICON_SIZES.SM;
  }, [isMobile]);

  const finalMessage = useMemo(() => {
    if (!message.trim().endsWith(".")) {
      return `${message}.`;
    }

    return message;
  }, [message]);

  return (
    <>
      <div className="flex-shrink-0">
        <div
          className={clsx([
            "flex",
            "flex-row",
            "items-center",
            "gap-1",
            "flex-shrink-0",
          ])}
        >
          <MdInfoOutline
            size={iconSize}
            className={clsx([
              "shrink-0",
              {
                "cursor-pointer": isMobile && hideTextInMobile,
              },
              iconClasses,
            ])}
            onClick={() => {
              if (isMobile && hideTextInMobile) {
                setShowDialog(true);
              }
            }}
          />
          <span
            className={clsx([
              "!text-[9px]",
              "md:!text-xs",
              {
                hidden: hideTextInMobile,
                inline: !hideTextInMobile,
              },
              "md:inline",
            ])}
          >
            {message}
          </span>
        </div>
      </div>

      {showDialog && (
        <AlertDialog
          title="Información"
          description={finalMessage}
          onClose={() => setShowDialog(false)}
        />
      )}
    </>
  );
};

export default ModalFooterMessage;
